import React from "react";


import styles from "./Footer.module.scss";
import Image from "../components/Global/Image";
import etoroLogo from "../images/etoro-logo.svg";

export default function Footer() {
    return (
        <>
            <footer className={styles.Main}>
                <div className={styles.Mentions}>
                    <div className="container">
                        <p>
                            <a href="https://www.etoro.com/fr/stocks/trading-and-investing-in-stocks/" rel={'noreferrer'} target={'_blank'}>
                                Investir en actions
                            </a>

                            &nbsp;&nbsp;&nbsp;&nbsp;

                            <a href="https://www.etoro.com/fr/investing/how-to-diversify-your-portfolio/" rel={'noreferrer'} target={'_blank'}>
                                Diversifier son portefeuille
                            </a>

                            &nbsp;&nbsp;&nbsp;&nbsp;

                            <a href="https://www.etoro.com/fr/stocks/risk-management/" rel={'noreferrer'} target={'_blank'}>
                                Gérer les risques
                            </a>
                            &nbsp;&nbsp;&nbsp;&nbsp;

                            <a href="#cookies">
                                Cookies
                            </a>
                        </p>
                        <Image src={etoroLogo} className={styles.Logo}/>
                    </div>
                </div>
            </footer>
        </>
    )
}
